"use client"

import { Eye as EyeIcon, EyeClosed as EyeOffIcon } from "@papier/ui/components/icons"
import { type ComponentProps, useState } from "react"

import { cn } from "@papier/ui/lib/utils"
import { Button } from "@papier/ui/components/ui/button"
import { Input } from "@papier/ui/components/ui/input"

export function PasswordInput({
    className,
    enableToggle = true,
    onChange,
    ...props
}: ComponentProps<typeof Input> & { enableToggle?: boolean }) {
    const [isVisible, setIsVisible] = useState(false)

    return (
        <div className="relative">
            <Input
                className={cn(enableToggle && "pr-10", className)}
                {...props}
                type={isVisible && enableToggle ? "text" : "password"}
                onChange={(event) => {
                    onChange?.(event)
                }}
            />

            {enableToggle && (
                <Button
                    className="bg-transparent! absolute right-0 -top-0.5"
                    aria-label={isVisible ? "Hide password" : "Show password"}
                    aria-controls={props.id}
                    disabled={props.disabled}
                    size="icon"
                    type="button"
                    variant="ghost"
                    onClick={() => setIsVisible(!isVisible)}
                >
                    {isVisible ? <EyeIcon /> : <EyeOffIcon />}
                </Button>
            )}
        </div>
    )
}
